import { render } from "./ErrorLayout.vue?vue&type=template&id=b6ecf1ce"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"

import "./ErrorLayout.vue?vue&type=style&index=0&id=b6ecf1ce&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__